module.exports = __webpack_public_path__ + "static/klimaatverandering-extreme-buien-nederland-83fe83aec2af4ca65e3428d0494baea3.jpg";